import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import ProjectsData from "../Data/ProjectsData";

const Projects = () => {
	return (
		<div className="bg-light pt-5" id="projects">
			<div className="container">
				<br />
				<Zoom>
					<h1 className="mb-5 text-center">
						<strong>PROJECTS</strong>
					</h1>
					<hr className="projects-header" />
				</Zoom>
				<div className="row justify-content-around">
					{ProjectsData.map(({ title, img, description, github, website }) => (
						<Fade top key={title}>
							<div className="col-md-6 col-lg-4 col-sm-6 mb-5">
								<div className="card">
									<img
										className="card-img-top"
										src={img}
										alt={title}
										loading="lazy"
									/>
									<div className="bg-dark text-white">
										<div className="card-body">
											<div className="card-title text-center font-weight-bold">
												<h5>{title}</h5>
											</div>
											<div className="card-text">{description}</div>
										</div>
										<div className="card-footer">
											<a
												href={github}
												target="_blank"
												rel="noreferrer"
												className="text-decoration-none"
											>
												<button className="btn btn-outline-danger btn-block font-weight-bold mb-2">
													GitHub
												</button>
											</a>
											<a
												href={website}
												target="_blank"
												rel="noreferrer"
												className="text-decoration-none"
											>
												<button className="btn btn-danger btn-block font-weight-bold">
													Website
												</button>
											</a>
										</div>
									</div>
								</div>
							</div>
						</Fade>
					))}
				</div>
			</div>
		</div>
	);
};

export default Projects;
